const LEGACY_NOTIFICATION_TYPE_MAP: Record<string, string> = {
  COMMENT_RECIBIDO: "COMMENT_RECEIVED",
  COMMENT_ENVIADO: "COMMENT_SENT",
  USER_COMMENT_ENVIADO: "COMMENT_SENT",
  COMMENT_RESPONDIDO: "COMMENT_REPLIED",
  USER_COMMENT_RESPONDIDO: "COMMENT_REPLIED",
  POSTULACION_SEND: "APPLICATION_SENT",
  POSTULACION_ACCEPTED: "APPLICATION_ACCEPTED",
  POSTULACION_NEGATED: "APPLICATION_REJECTED",
  PRESUPUESTO_ENVIADO: "BUDGET_SENT",
  PRESUPUESTO_ACEPTADO: "BUDGET_ACCEPTED",
  PRESUPUESTO_NEGADO: "BUDGET_REJECTED",
  QUOTATION_SEND: "QUOTATION_SENT",
  QUOTATION_UPDATE: "QUOTATION_UPDATED",
  USER_POSTULATION_SEND: "USER_APPLICATION_SENT",
  USER_FEATURED_POSTULATION_SEND: "USER_FEATURED_APPLICATION_SENT",
  USER_POSTULATION_ACCEPTED: "USER_APPLICATION_ACCEPTED",
  USER_POSTULATION_NEGATED: "USER_APPLICATION_REJECTED",
  NEW_PROFILE_VIEW: "PROFILE_VIEW_RECEIVED",
  USER_NEW_PROFILE_VIEW: "PROFILE_VIEW_RECEIVED",
  NEW_PROFILE_REVIEW: "PROFILE_REVIEW_RECEIVED",
  POST_LIKE_SEND: "POST_LIKED",
  POST_COMMENT_SEND: "POST_COMMENTED",
  POST_COMMENT_RESPONSE: "POST_COMMENT_REPLIED",
  NEW_COINCIDENCES: "NEW_MATCHES",
  NEW_JOB_APLICATION: "NEW_JOB_APPLICATION",
  NEW_QUESTION: "QUESTION_RECEIVED",
  QUESTION_RESPONDIDO: "QUESTION_REPLIED",
  MATERIAL_DEMAND_ALERT_GENERIC: "GENERIC_MATERIAL_DEMAND_ALERT",
};

export function normalizeNotificationType(type: string): string {
  const trimmed = type.trim();
  if (!trimmed) return trimmed;
  return LEGACY_NOTIFICATION_TYPE_MAP[trimmed] ?? trimmed;
}
